import { render } from "./MemberEduardo.vue?vue&type=template&id=3f0c9d50"
import script from "./MemberEduardo.vue?vue&type=script&lang=js"
export * from "./MemberEduardo.vue?vue&type=script&lang=js"

import "./MemberEduardo.vue?vue&type=style&index=0&id=3f0c9d50&lang=css"

import exportComponent from "C:\\Users\\DEV-HMP\\Documents\\TPM_Site\\website\\WebTPM\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__